<div id="fluency-main-content" class="modal notification-modal" tabindex="-1" role="dialog" *ngIf="activateModal">
    <div class="modal-dialog fluency-modal" role="document">
        <div class="modal-content">
            <button type="button" class="close" (click)="closeModal()" data-dismiss="modal" aria-label="Close"></button>
            <div class="modal-body">
                <div class="container">
                    <div class="container-fluid row {{ format }}-view fluency-header">

                        <div class="row col-xs-12 col-lg-12 fluency-report-section no-gutter">
                            <div class="fluency-title"> Fluency Report | {{learnerName}}</div>
                            <div class="fluency-print-report">
                                <button class="fluency-print-btn" (click)="printReport()"></button>
                            </div>
                        </div>
                    </div>

                    <div class="row no-gutter">

                        <div class="col-xs-12 fluency-message" *ngIf="!!getDisplayRecordings()">
                            <div class="book-info">
                                <img src="{{getCoverImage()}}" class="no-gutter fluency-cover-image" />
                                <div class="fluency-selection-title">
                                    {{ report.fullTitle }}
                                </div>
                            </div>
                           
                            <div class="message-block">
                                <div [ngClass]="getRecordingBadge()"></div>
                                <div class="fluency-message-text text-sm-left">{{message}}</div>
                            </div>
                          
                        </div>

                        <div class="row col-xs-12 fluency-free-panel">
                            <div class="fluency-graph-area col-xs-12 offset-lg-0 col-lg-7">
                                <div class="fluency-word-correct">Words Correct Per Minute
                                    <div class="words-count">Best Initial Words Correct Per Minute: <span>{{
                                        report.highestWCPM}}</span> </div>
                                </div>
                                
                                <div class="offset-xs-1 offset-lg-0 graph-area">
                                    <div class="goal-container" [ngStyle]="getGoalLinePosition()">
                                        <div class="goal-label">GOAL : {{goal}} </div>
                                        <hr class="goal-line"/>
                                    </div>
                                    <div class="offset-xs-1 offset-lg-0 base fluency"
                                         [ngStyle]="{'width': determineBaseWidth(report)}"></div>



                                    <div class="bars">
                                        <div class="bar fluency bar-overlay-parent"
                                             *ngFor="let record of getDisplayRecordings(); let idx = index"
                                             [ngStyle]="getBarStyle(record, idx)"
                                             [ngClass]="getCurrentBar(idx)">
                                            <div *ngIf="showFirework(record, idx)" class="fluency-bar-fireworks"
                                                 [ngStyle]="getFireworksPositioning(record)"></div>
                                            <div class="bar-wcpm" [ngStyle]="showRecordBold(idx)">{{ record.wcpm }}</div>
                                        </div>
                                    </div>



                                    <div class="bar-date">
                                        <span class="bar-date-title">Date:</span>
                                        <span class="bar-date-wcpm"
                                              *ngFor="let record of getDisplayRecordings(); let idx = index"
                                              [ngStyle]="getBarDateStyle(idx)">
                                        {{ parseDate(record.recordDate) }}
                                    </span>
                                    </div>
                                   
                                </div>
                            </div>
                            <div class="words-practice-section col-xs-12 col-lg-4"
                                 [ngClass]="{'no-gutter': belowWordsPracticeGutter()}">
                                <div class="words-practice-border">
                                    <h5 class="words-practice-title">Words to Practice</h5>

                                    <div class="words-practice">
                                        <div class="words-practice-vertical hidden-md-down">
                                            <ul class="list-group hidden-md-down">
                                                <li *ngFor="let word of getReviewWords()"
                                                    class="list-group-item word-item">
                                                <span *ngIf="!!word"
                                                      [innerHTML]="word.word"
                                                      class="item-span {{wordColorClass(word.wordColor)}}"></span></li>

                                            </ul>
                                        </div>

                                        <div class="hidden-lg-up row no-gutter">
                                            <div *ngFor="let tableList of reviewWordsRange; let tidx = index"
                                                 class="col-xs-4">
                                                <ul class="list-group">
                                                    <li *ngFor="let word of getReviewWordsTable(tidx); let idx = index"
                                                        class="list-group-item word-item">
                                                        <span *ngIf="!!word"
                                                              [innerHTML]="word.word"
                                                              class="{{wordColorClass(word.wordColor)}}">
                                                        </span>

                                                    </li>
                                                </ul>
                                            </div>

                                        </div>

                                        <span class="shadow"></span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<div class="modal-backdrop fade in" *ngIf="activateModal"></div>
